// export const enum MutationNames {
//   updatePatientWithLiveDataLatests = 'PATIENT_WITH_LIVE_DATA_LATEST_UPDATE_PATIENT_WITH_LIVE_DATA_LATESTS',
//   updatePatientWithHistories = 'PATIENT_WITH_LIVE_DATA_LATEST_UPDATE_PATIENT_WITH_HISTORIES',
//   resetPatientWitLiveData = 'PATIENT_WITH_LIVE_DATA_LATEST_RESET_PATIENT_WITH_LIVE_DATA',
// }

export const enum LatestVisitMutationNames {
  updatePatientWithLatestVisit = 'PATIENT_WITH_LATEST_VISIT_UPDATE_PATIENT_WITH_LATEST_VISIT',
}

export const enum LatestVisitActionNames {
  // getPatientWithLastVisit = 'PATIENT_WITH_LAST_VISIT_GET_PATIENT_WITH_LAST_VISIT',
  getPatientWithLatestVisitById = 'PATIENT_WITH_LATEST_VISIT_GET_PATIENT_WITH_LATEST_VISIT_BY_ID',
}

export const enum LatestVisitGetterNames {
  patientWithLatestVisits = 'PATIENT_WITH_LATEST_VISIT_PATIENT_WITH_LATEST_VISITS',
}
